import "./production-execution-styles";
import { SystemAdministratorProductionBoard } from "./terminal-admin/SystemAdministratorProductionBoard";
import { TechnicalManagerProductionBoard } from "./terminal-admin/TechnicalManagerProductionBoard";
import { OperatorTablet } from "./operator/OperatorTablet";
import type { ProductionWorkspaceProps } from "./production-workspace-contract";
import { SupervisorBoard } from "./supervisor/SupervisorBoard";

import { ProductionManagerDashboard } from "../production-manager/ProductionManagerDashboard";

import { OperatorTerminalShell } from "./terminal/OperatorTerminalShell";
import { TerminalEnrollment } from "./terminal/TerminalEnrollment";
import { TemporaryTakeoverDialog } from "./terminal/TemporaryTakeoverDialog";
import { OperatorPinLogin } from "./terminal/OperatorPinLogin";

export function ProductionExecutionModule(props: ProductionWorkspaceProps) {
  return props.user.role === "SISTEM_YONETICISI" ? (
    <SystemAdministratorProductionBoard {...props} />
  ) : props.user.role === "TEKNIK_MUDURU" ? (
    <TechnicalManagerProductionBoard {...props} />
  ) : props.user.role === "URETIM_YONETICISI" ? (
    <ProductionManagerDashboard
      user={props.user}
      dataRefreshVersion={props.dataRefreshVersion}
      onLogout={props.onLogout}
    />
  ) : props.user.role === "URETIM_OPERATORU" ? (
    <OperatorTerminalShell
      user={props.user}
      notify={props.notify}
      onLogout={props.onLogout}
      onBack={props.onBack}
      renderEnrollment={(enrollmentProps) => (
        <TerminalEnrollment {...enrollmentProps} />
      )}
      renderTemporaryTakeover={(takeoverProps) => (
        <TemporaryTakeoverDialog {...takeoverProps} notify={props.notify} />
      )}
      renderPinLogin={(loginProps) => <OperatorPinLogin {...loginProps} />}
      renderActiveTerminal={(terminalProps) => (
        <OperatorTablet
          key={terminalProps.terminalContext.session?.id}
          {...props}
          {...terminalProps}
        />
      )}
    />
  ) : (
    <SupervisorBoard {...props} />
  );
}
